import { CdkDragDrop, moveItemInArray, transferArrayItem, CdkDropList } from '@angular/cdk/drag-drop';
import { Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import { DataserviceService } from '../dataservice.service';
import { firstValueFrom } from 'rxjs';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalService } from 'ng-zorro-antd/modal';
import { FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-onboarding-board',
  templateUrl: './onboarding-board.component.html',
  styleUrl: './onboarding-board.component.css'
})
export class OnboardingBoardComponent implements OnInit {
  @ViewChildren('cardList') cardDropLists!: QueryList<CdkDropList>;
  currentUser: any;
  onboarding: any[] = [];
  bucketColumns: any[] = [];
  connectedLists: CdkDropList[] = [];
  actionsModal: boolean = false;
  actionsByBuckets: any[] = [];
  selectedCard: any;
  isSpinning: boolean = false;
  spinningMsg: any;
  cardHistoryDrawer: boolean = false;
  cardHistoryData: any;
  actionHistoryDrawer: boolean = false;
  actionDrawerData: any;
  noteForm: FormGroup;

  constructor(private data: DataserviceService, private message: NzMessageService, private modal: NzModalService) {
    this.currentUser = JSON.parse(localStorage.getItem('user')!);

    this.noteForm = new FormGroup({
      'note': new FormControl(null, [Validators.required, Validators.maxLength(150)])
    })
  }

  ngOnInit() {
    this.isSpinning = true;
    this.spinningMsg = 'Loading boards...'
    this.getBoardByCompany();
  }

  ngAfterViewChecked() {
    if (this.cardDropLists?.length && this.cardDropLists.length !== this.connectedLists.length) {
      setTimeout(() => {
        this.connectedLists = this.cardDropLists.toArray();
      }, 0);
    }
  }

  async getBoardByCompany() {
    this.data.getData(`onboarding/company/${this.currentUser.company_id}/board`)
      .subscribe({ 
        next: (res: any) => {
          if(res?.result == 'success') {
            this.bucketColumns = res?.data?.buckets || []
          }
          this.isSpinning = false;
        },
        error: (err: any) => {
          console.log(err)
          alert('Failed to get onboarding cards by company')
        }
      })
  }

  /** Reorder bucket columns (Trello-style). Persists via backend. */
  async dropColumn(event: CdkDragDrop<any[]>) {
    if (event.previousIndex === event.currentIndex) return;
    const moved = this.bucketColumns[event.previousIndex];
    if (!moved?.id) return;
    moveItemInArray(this.bucketColumns, event.previousIndex, event.currentIndex);
    const placeAfterId = event.currentIndex === 0 ? 'start' : this.bucketColumns[event.currentIndex - 1].id;
    try {
      this.spinningMsg = 'Updating order...'
      this.isSpinning = true;
      const payload = { move_to_after_id: placeAfterId, bucket_id: moved.id };
      await firstValueFrom(this.data.postData(payload, `onboarding/update`));
      this.message.success('Columns reordered');
      setTimeout(() => {
        this.isSpinning = false;
      }, 250)
    } catch (e) {
      moveItemInArray(this.bucketColumns, event.currentIndex, event.previousIndex);
      this.message.error('Failed to reorder columns');
      setTimeout(() => {
        this.isSpinning = false;
      }, 250)
    }
  }

  async drop(event: CdkDragDrop<any[]>, arr: any) {
    let card = event.previousContainer.data[event.previousIndex]
    //Check if the card was moved into the same bucket
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
      return;
    }else {
      this.spinningMsg = 'Moving user...'
      this.isSpinning = true;
      transferArrayItem( event.previousContainer.data, event.container.data, event.previousIndex, event.currentIndex);

      let obj = {
        user_id: card?.userId,
        new_bucket: event.container.id,
        old_bucket: event.previousContainer.id,
        assignment_id: card?.assignmentId
      }

      this.data.postData(obj, 'onboarding/assign-onboarding-to-user')
        .subscribe({
          next: (res: any) => {
            let i = arr.indexOf(card)
            arr[i] = res?.data
            this.message.success(`User moved successfully!`);
            setTimeout(() => {
              this.isSpinning = false;
            }, 250)
          },
          error: (err: any) => {
            this.message.error(`Failed to move user!`);
            moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
            setTimeout(() => {
              this.isSpinning = false;
            }, 250)
          }
        })
    }
  }

  openCard(card: any) {
    this.spinningMsg = 'Getting users actions...'
    this.isSpinning = true;
    this.selectedCard = card;
    this.data.getData(`actions/user-actions/${card.userId}`)
      .subscribe({
        next: (res: any) => {
          if(res?.result == 'success') {
            this.actionsByBuckets = res?.data;
            this.actionsModal = true;
          }
          this.isSpinning = false;
        },
        error: (err: any) => {
          console.log('err: ', err)
          alert('Error getting card details')
          this.isSpinning = false;
        }
      })
  }

  toggleStatus(action: any) {
    let status: any;
    if(action.status == 'done'){
      status = 'not done'
    }
    else if(action.status == 'not done'){
      status = 'done'
    }
    this.modal.confirm({
      nzTitle: `<i>Are you sure you want to change status to ${status}?</i>`,
      nzOnOk: () => {

        let body = {
          id: action.id,
          status: status
        }

        this.data.postData(body, 'actions/update-user-action')
          .subscribe({
            next: (res: any) => {
              if(res?.result == 'success') {
                action.status = status;
              }else {
                alert('Unable to update action');
              }
            }, 
            error: (err: any) => {
              console.log('error in toggleStatus: ', err);
              alert('Failed to update action');
            }
          })
      },
    });
  }

  actionProgress(b: any){
    const done = b.actions?.filter((num: any) => num.status == 'done')
    let perc = (done.length / b.actions?.length)*100
    return perc
  }

  cancelActionsModal() {
    this.spinningMsg = 'Updating user card...'
    this.isSpinning = true;
    if('actions' in this.actionsByBuckets) {
      const [arr] = this.actionsByBuckets?.filter((ab: any) => ab.bucket_id == this.selectedCard.bucketId)
      const newActionsCount = arr.actions?.filter((action: any) => action.status == 'done')
    if('doneCount' in this.selectedCard) {
      this.selectedCard.doneCount = newActionsCount?.length || 0;
    }
    }
    this.actionsModal = false;
    setTimeout(() => {
      this.isSpinning = false;
    }, 250)
  }

  viewActionHistory(action: any) {
    this.actionDrawerData = action;
    this.actionHistoryDrawer = true;
  }

  closeDrawer() {
    this.actionHistoryDrawer = false;
    this.actionDrawerData = null;
    this.noteForm.reset();
  }

  sort() {
    return this.actionDrawerData?.history?.sort((a: any, b: any) => {
      const dateB = b.date ? new Date(b.date).getTime() : 0;
      const dateA = a.date ? new Date(a.date).getTime() : 0;
      return dateB - dateA;
    });
  }

  sortCardHist() {
    return this.cardHistoryData?.sort((a: any, b: any) => {
      const dateB = b.date ? new Date(b.date).getTime() : 0;
      const dateA = a.date ? new Date(a.date).getTime() : 0;
      return dateB - dateA;
    });
  }

  viewCardHistory() {
    this.spinningMsg = 'Getting card history...'
    this.isSpinning = true;
    this.data.getData(`onboarding/get-card-history/${this.selectedCard?.assignmentId}`)
      .subscribe({
        next: (res: any) => {
          this.cardHistoryData = res;
          this.cardHistoryDrawer = true;
          setTimeout(() => {
            this.isSpinning = false;
          }, 250)
        },
        error: (err: any) => {
          alert('Error when attempting to get card history')
          setTimeout(() => {
            this.isSpinning = false;
          }, 250)
        }
      })
  }

  addNote() {
    let obj = {
      id: this.actionDrawerData?.id,
      newNote: {
        note: this.noteForm.get('note')?.value,
        by: this.currentUser?.first_name + ' ' + this.currentUser?.last_name,
        user_id: this.currentUser?.id,
        date: new Date().toISOString()
      }
    }

    this.data.postData(obj, 'actions/add-action-note')
      .subscribe({
        next: (res: any) => {
          if(res?.result == 'success') {
            this.actionDrawerData?.history?.push(obj?.newNote);
            this.noteForm.reset();
            this.message.success(`Note added!`);
          }else {
            alert('Failed to add new note')
          }
        },
        error: (err: any) => {
          console.log('error trying to add new note: ', err)
          alert('Error when attempting to add new note')
        }
      })
  }

  addCardNote() {
    let obj = {
      id: this.selectedCard?.assignmentId,
      newNote: {
        note: this.noteForm.get('note')?.value,
        by: this.currentUser?.first_name + ' ' + this.currentUser?.last_name,
        user_id: this.currentUser?.id,
        date: new Date().toISOString()
      }
    }
    
    this.data.postData(obj, `onboarding/add-card-note`)
      .subscribe({
        next: (res: any) => {
          if(res?.result == 'success') {
            this.cardHistoryData?.push(obj?.newNote);
            this.noteForm.reset();
            this.message.success(`Note added!`);
          }else {
            alert('Failed to add new note')
          }
        },
        error: (err: any) => {
          console.log('error trying to add new note: ', err)
          alert('Error when attempting to add new note')
        }
      })


  }

  closeCardDrawer() {
    this.cardHistoryDrawer = false;
    this.cardHistoryData = null;
    this.noteForm.reset();
  }

}